import { ReactNode } from 'react';
import { ContainerTV } from './variants';
import { VariantProps } from 'tailwind-variants';

interface IContainer extends VariantProps<typeof ContainerTV> {
  children?: ReactNode;
  className?: string;
}

export default function Container({
  children,
  type = 'default',
  className,
  direction,
  gap,
}: IContainer) {
  return (
    <div className={ContainerTV({ type, className, direction, gap })}>
      {children}
    </div>
  );
}
